<template>
  <div class="card-invite card-user">

    <table class="table table-hover table-responsive-md">
      <div class="validation-count">
        <div class="subtitle">{{ total }} {{ total > 1 ? 'resultados' : 'resultado' }}</div>
        <div v-if="this.validations">
          <b-form-checkbox
            class="subtitle"
            id="checkbox-serviceStatus"
            v-model="serviceStatus"
            @change="serviceStatusSelected"
          >
            Desabilitar <b-badge pill variant="warning">link criado</b-badge>
          </b-form-checkbox>
        </div>
      </div>
      <tbody>
      <tr v-for="tx in txs.list" v-bind:key="tx.id" class="d-flex">
        <td scope="row" class="col-2">
          <div><router-link :to="{name: 'ValidationDetailsNew', params: { txid: tx.uuid }}"><strong>#{{ tx.id | numeral('00000') }}</strong></router-link></div>
          <div class="subtitle">{{tx.dateCreated | moment}} - {{tx.dateCreated | moment-hour}}</div>
        </td>
        <td class="col-3">
          <img v-if="tx.profilePicture" :src="tx.profilePicture" class="img-avatar img-profile" style="height: 50px;"/>
          <div>
            <div class="subtitle"><strong>{{tx.buyerName}} <b-badge pill :variant="(tx.rating === 'A' || tx.rating === 'B') ? 'success' : ((tx.rating === 'D' || tx.rating === 'E') ? 'danger' : 'warning')">{{ tx.rating }}</b-badge></strong></div>
            <div class="subtitle">{{tx.amount  | numeral('$ 0,0.00')}}</div>
          </div>
        </td>
        <td class="col-3">
          <div class="subtitle">{{ tx.buyerEmail }}</div>
          <div class="subtitle">{{ tx.buyerPhone }}</div>
        </td>
        <td class="col-4">
          <img height="50" :src="'/static/sellers/' +  tx.sellerName[0].toUpperCase() + tx.sellerName.toLowerCase().replace(/ /g, '_').slice(1) + '.png'" class="img-profile"/>
          <div>
            <div class="subtitle"><strong>{{ tx.sellerName }}</strong></div>
            <div class="subtitle">
              <b-badge v-if="tx.serviceStatus" pill :variant="(tx.serviceStatus === 'Link criado') ? 'warning' : ((tx.serviceStatus === 'Documentos enviados') ? 'success' : (tx.serviceStatus === 'Resposta cliente') ? 'danger' : 'info')">
                {{ tx.serviceStatus }}
              </b-badge>
              <strong v-else>{{ tx.currentStep }}</strong>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
    <b-pagination size="md" align="center" :total-rows="total" v-model="currentPage" :per-page="max" @change="fetchData">
    </b-pagination>
  </div>
</template>

<script>
import Button from '../button/Button.vue'
import Input from '../form/Input.vue'

export default {
  props: {
    'validations': {
      default: true
    },
    'refreshList': {
    },
    'orderList': {
    },
    seller: {
      type: Number
    }
  },
  components: {
    'input-component': Input,
    'button-component': Button
  },
  data () {
    return {
      name: null,
      txs: [],
      currentPage: 1,
      max: 10,
      total: 0
    }
  },
  mounted () {
    this.fetchData(parseInt(this.$cookie.get('validations_currentPage')) === null
      ? 1
      : parseInt(this.$cookie.get('validations_currentPage')))
  },
  methods: {
    fetchData: function (val) {
      var page = val || this.currentPage
      this.$cookie.set('validations_currentPage', page, 1)
      var nameValue = ''
      if (this.name) {
        nameValue = this.removeDots(this.name)
      }
      this.$http.get('api/validations', {params: {offset: this.max * (page - 1), max: this.max, name: nameValue, order: this.orderList, validations: this.validations, serviceStatus: this.serviceStatus, seller: this.seller}})
        .then(function (res) {
          console.log(res)
          this.txs = res.data
          this.total = res.data.total
          this.$nextTick(() => {
            this.currentPage = page
          })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    removeDots: function (name) {
      return name.replace(/\.|-|\(|\) |\)/g, '')
    },
    buscarComFiltro: function (filtro, item) {
      console.log(filtro)
      this.name = filtro
      this.currentPage = 1
      this.fetchData()
    },
    convertTime: function (val) {
      var seconds = Math.floor(val % 60).toString()
      var minutes = Math.floor(val / 60).toString()
      if (seconds.length === 1) {
        seconds = '0' + seconds
      }
      return minutes + 'm' + seconds + 's'
    },
    extractHostname: function (url) {
      var hostname

      if (url) {
        if (url.indexOf('://') > -1) {
          hostname = url.split('/')[2]
        } else {
          hostname = url.split('/')[0]
        }

        hostname = hostname.split(':')[0]
        hostname = hostname.split('?')[0]
      }

      return hostname
    },
    serviceStatusSelected (value) {
      this.$store.dispatch('serviceStatusSelected', value)
    }
  },
  computed: {
    serviceStatus: {
      get () {
        return this.$store.state.serviceStatus
      },
      set (value) {}
    }
  },
  watch: {
    'refreshList' () {
      this.fetchData()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/variaveis.scss";
  @import "../../../assets/scss/mixins.scss";
  @import "../../../assets/scss/card.scss";
  .card-user {
    .avatar {
      width: 40px;
    }
    .card-invite-body {
      top: 102px;
    }
  }
  .img-profile {
    float: left;
    margin-right:1rem;
  }
  .validation-count {
    padding: 12px !important;
    display: flex !important;
    justify-content: space-between !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/partial/validations/ValidatonsListNew.vue